import moment from 'moment';
import sanitizer  from 'sanitizer';

export function smallStatus(data, type ) {
  if ( type === 'display' ) {
    if(!data) return null;
    return `<div><b class="${data}">${data}</b></div>`;
  }
  return data;
}

export function largeStatus(data, type ) {
  if ( type === 'display' ) {
    if(!data) return null;
    return `<div class="${data}"><b>${data}</b></div>`;
  }
  return data;
}

export function classFromData(renderer){
  return function (data, type, row){
    const result = renderer ? renderer(data, type, row) : data;
    if(!row.className) return result;
    else return `<span class="${row.className}">${result}</span>`;
  }
}

export function smallNumber(data, type, row) {
  if ( type === 'display' ) {
    if(typeof data === 'undefined' || data === null) return null;
    return parseFloat(data).toFixed(2);
  }
  return data;
}

export function penceAsPounds(data, type, row) {
  if ( type === 'display' ) {
    if(typeof data === 'undefined' || data === null) return null;
    return '£' + parseFloat(data/100).toFixed(2);
  }
  return data;
}

export function localMediumDate(data, type ) {
  // If display is requested, format the date
  if ( type === 'display' || type === 'filter') {
    return data ?  moment(data).format('LLL') : null;
  }

  // Otherwise the data type requested (`type`) is type detection or
  // sorting data, for which we want to use the integer, so just return
  // that, unaltered
  return data;
}

export function lastFinishedLeg(row, type) {
  if(!row.legs || !row.legs.length) return null;
  let leg1, leg2, lastLeg, prefix;

  leg2 = row.legs.find(leg => leg.direction === 'outbound');

  if(leg2) {
    if (leg2.end) {
      lastLeg = leg2.end;
      prefix = 'Leg2 ended';
    }else if(leg2.start){
      lastLeg = leg2.start;
      prefix = 'Leg2 started';
    }else{
      leg1 = row.legs.find(leg => leg.direction === 'inbound');
    }
  }

  if(leg1){
    if (leg1.end) {
      lastLeg = leg1.end;
      prefix = 'Leg1 ended';
    }else if(leg1.start){
      lastLeg = leg1.start;
      prefix = 'Leg1 started';
    }
  }

  if(type === 'sort') return lastLeg;

  if(!lastLeg) return 'No legs started';
  return prefix + '<br/>' + localMediumDate(lastLeg, type, row);
}

export function humanDuration(data, type, row ) {
  if ( type === 'display' ) {
    if(!data) return null;
    return moment.duration(data).humanize();
  }
  return data;
}

export function succinctDateTime(data, type ) {
  if ( type === 'display' || type === 'filter') {
    return data ?  moment(data).format('D MMM YYYY - hh:mm A') : null;
  }
  return data;
}

export function largeMasterStatus(data, type ) {
  if ( type === 'display' || type === 'filter') {
    if(!data) return null;
    return `<div class="${data}"><b>${data}</b></div>`;
  }
  return data;
}

export function vehicleIdToVRM(data, type ) {
  if ( type === 'display' || type === 'filter') {
    if(!data) return null;
    const dash = data.indexOf('-');
    if(dash <= 0) return null;
    return data.substring(0,dash).replace(/\s/g,'').toUpperCase();
  }
  return data;
}

export function deleteButton(data, type ) {
  if ( type === 'display' || type === 'filter') {
    if(!data) return null;
    return `<button type="button" class="btn btn-danger create-btn"><i class="fa fa-trash fa-lg" aria-hidden="true"></i> Delete</button>`;
  }
  return data;
}

export function customerName(data, type) {
  if(!data) return '-';
  const {firstName, lastName} = data;
  return sanitizer.escape(`${firstName} ${lastName}`);
}

export function collectionDelivery(data, type) {
  if(!data) return '-';
  const {collectionDateTimeLocal, deliveryDateTimeLocal} = data;
  const collection = moment(collectionDateTimeLocal);
  const delivery = moment(deliveryDateTimeLocal);
  if(collection.isSame(delivery, 'day'))
    return `${collection.format('DD MMM YYYY, h:mm a')} → ${delivery.format('h:mm a')}`;
  else
    return `${collection.format('DD MMM YYYY, h:mm a')} → ${delivery.format('DD MMM, h:mm a')}`;
}

export function formattedDate(data, type) {
  return moment(data).format('YYYY-MM-DD, ddd')
}

export function formatDateTime(data) {
  return moment(data).format('DD MMM, HH:mm:ss')
}

export function cutOffText(data) {
  let str
  const cutoff = 15
  if(typeof data !== 'string') str = data.toString()
  else str = data
  return str.length < cutoff ? str : str.substr(0, cutoff - 1) + '&#8230';
}

export function caseManagerInitials(data, type) {
  if(typeof data === 'string') return data.split('.').map(n => n.slice(0,1)).join('').toUpperCase();
  return '';
}